import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import recommendedForYouQuery from './query'
import {
  IRecommendedForYouVariables,
  IRecommendedForYouResponse,
} from './types'

/**
 * Hook declaration to obtain a lazy query of personalised "recommended
 * for you" products. Ships dark in Phase 1 — wired in code but not yet
 * activated by SCS config.
 * @param options: LazyQueryHookOptions
 * @internal
 */
const useLazyRecommendedForYou = (
  options?: LazyQueryHookOptions<
    IRecommendedForYouResponse,
    IRecommendedForYouVariables
  >,
) => {
  return useLazyQuery<
    IRecommendedForYouResponse,
    IRecommendedForYouVariables
  >(recommendedForYouQuery, {
    ...options,
    fetchPolicy: 'no-cache',
  })
}

export { useLazyRecommendedForYou }
